import { Injectable } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { BehaviorSubject } from 'rxjs';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';
import { UpdatePhoneModalComponent } from 'src/app/components/modals/update-phone-modal/update-phone-modal.component';
import { TextModalContentUI } from 'src/app/interfaces/text-modal.interface';
import { ModalContentKey } from 'src/app/utils/enums';
import { ModalTexts } from 'src/app/utils/text-content';

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	private modalTextSubject: BehaviorSubject<TextModalContentUI> = new BehaviorSubject(
		ModalTexts.ABANDON_MODAL
	);
	readonly modalText$ = this.modalTextSubject.asObservable();

	constructor(private readonly wkModal: BciWkModalService) {}

	openPhoneUpdateModal(): void {
		this.wkModal.open(UpdatePhoneModalComponent);
	}

	openGenericModal(type: ModalContentKey): void {
		this.modalTextSubject.next(ModalTexts[type]);
		this.wkModal.open(GenericModalComponent);
	}

	closeModal() {
		this.wkModal.close();
	}

	setStyles(styles: { containerStyle?: Record<string, string> }) {
		this.wkModal.setStyles(styles);
	}
}
